import React, { useEffect, useState } from 'react';
import './calendarStandaloneForm.css';
import { getDates } from "../../helpers/getDates";

const CalendarStandaloneForm = ({ date, handler, selectedDays }) => {

    // Если не передана дата, или дата пустая строка
    if (!date) {
        date = new Date().toLocaleDateString('fr-CA');
    }

    const [dates, setDates] = useState({});

    // Переключение месяца
    const changeMonth = d => {
        setDates(getDates(d));
    };

    useEffect(() => {
        setDates(getDates(date));
    }, [date]);

    return (
        <div className="calendarsf">
            <div className="calendarsf__header">
                <div className="calendarsf__navs">
                    <i
                        className="calendarsf__nav calendar__nav--prev"
                        onClick={ () => changeMonth(dates.prev) }
                    />
                    <i
                        className="calendarsf__nav calendar__nav--next"
                        onClick={ () => changeMonth(dates.next) }
                    />
                </div>
                <div className="calendarsf__month">{ dates.monthYear }</div>
            </div>
            <div className="calendarsf__days">
                <div className="calendarsf__day">Пн</div>
                <div className="calendarsf__day">Вт</div>
                <div className="calendarsf__day">Ср</div>
                <div className="calendarsf__day">Чт</div>
                <div className="calendarsf__day">Пт</div>
                <div className="calendarsf__day calendar__day--weekend">Сб</div>
                <div className="calendarsf__day calendar__day--weekend">Вс</div>
            </div>
            <div className="calendarsf__items">
                {
                    dates.days?.map((date, index) => {
                        return (
                            <div
                                key={ index }
                                className={
                                    `
                                    calendar__item
                                    ${ dates.today === date.date ? 'calendar__item--today' : '' }
                                    ${ selectedDays?.includes(date.date) ? 'calendar__item--active' : '' }
                                    ${ date.inactive ? 'calendar__item--inactive' : '' }
                                    `
                                }
                                onClick={ () => handler(date.date) }
                            >{ date.day }</div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default CalendarStandaloneForm;